// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__1itaz","anim":"Home_anim__1MQ4Z","illu":"Home_illu__2jDsS","anim-left":"Home_anim-left__vOfVn","puzzle":"Home_puzzle__3-Liz"};